import '../../css/styles.css';
import IranFlag from "../../assets/images/iran.webp";
import React, {useEffect, useState} from "react";
import api from "../../api";
import Cookies from "js-cookie";
import Report from "../reports/Report";
import {toast, ToastContainer} from "react-toastify";
import {p2e, e2p} from "../../utils/utils";
import {useNavigate} from "react-router-dom";

const UserPanel = () => {
    const [car, setCar] = useState(null);
    const [error, setError] = useState(null);
    const [history, setHistory] = useState([]);
    const [showHistory, setShowHistory] = useState(false);
    const [plateNo, setPlateNo] = useState({
        firstNo: "",
        letter: "",
        secondNo: "",
        thirdNo: "",
    });
    const [nationalCode, setNationalCode] = useState("");
    
    const navigate = useNavigate();

    const handleInputChange = (event) => {
        setPlateNo({
            ...plateNo,
            [event.target.name]: p2e(event.target.value),
        });
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (!parseInt(plateNo.firstNo) || !parseInt(plateNo.secondNo) || !parseInt(plateNo.thirdNo)) {
            toast.error('لطفا مقادیر صحیح وارد کنید', {
                toastId: 'invalid-plate-no',
            });
            return;
        }
        
        const queryParams = {
            plateNo: `${plateNo.firstNo}${plateNo.letter}${plateNo.secondNo} ${plateNo.thirdNo}`,
            nationalCode: nationalCode,
        };
        
        if (queryParams.plateNo === '  ' && nationalCode === '') {
            toast.error('لطفا مقادیر مورد نظر را وارد کنید', {
                toastId: 'empty-plate-no',
            });
            return;
        }

        api.get(`/car`, {params: queryParams})
            .then(res => {
                setCar(res.data.data[0]);
                toast.success(res.data.message, {
                    toastId: 'car-found',
                });
            })
            .catch(err => {
                toast.error(err.response.data.message, {
                    toastId: 'car-not-found',
                });
                setCar(null);
            });
    };

    useEffect(() => {
        if (car) {
            api.get(`/repair-request/history/${car.id}`)
                .then(res => {
                    setHistory(res.data.data);
                })
                .catch(err => {
                    toast.error('مشکلی پیش آمده لطفا دوباره تلاش کنید')
                    setHistory([]);
                });
        }

        let timeout;
        if (error) {
            timeout = setTimeout(() => {
                setError(null);
            }, 3000);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [error, car]);

    const handleShowHistory = () => {
        setShowHistory(true);
    }

    const handleHideHistory = () => {
        setShowHistory(false);
    }
    
    const goToAddCar = () => {
        const inputPlateNo = `${plateNo.thirdNo}${plateNo.firstNo} ${plateNo.secondNo}${plateNo.letter}`;
        
        if (inputPlateNo !== '') {
            navigate(`/add-car?plateNo=${inputPlateNo}`);
        } else {
            navigate('/add-car');
        }
    };

    const handleReception = async (carId) => {
        if (Cookies.get('role') === 'ادمین') {
            toast.error('ادمین نمیتواند پذیرش انجام دهد', {
                toastId: 'admin-reception',
            })
            return;
        }
        try {
            const requestBody = {
                status: 2,
                kilometerage: 0,
                owner_permission: 1,
                amount_of_fuel: '',
                description: '',
                car_id: carId,
            };
            const response = await api.post('/repair-request', requestBody);
            const requestId = response.data.data.id
            window.location.href = `/car/${car.id}/reception/${requestId}`
        } catch (err) {
            toast.error('')
        }
    }

    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    // autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    limit={1}
                />
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                        <div className="card rounded-4 border-2 border-dark mb-2">
                            <h5 className="card-header text-center bg-dark text-white">پلاک را وارد نمایید</h5>
                            <div className="card-body">
                                <form onSubmit={handleFormSubmit}>
                                    <div className="row pelak w-auto g-0 mb-3">
                                        <div className="col">
                                            <div className="row g-0">
                                                <div className="col border-start">
                                                    <p className="text-center m-0 fw-bold iranNo">ایران</p>
                                                    <div>
                                                        <input
                                                            className="border-0 text-center"
                                                            type="text"
                                                            onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                                            placeholder="44"
                                                            name="thirdNo"
                                                            value={plateNo.thirdNo}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <input
                                                        className="border-0 text-center"
                                                        type="text"
                                                        placeholder="123"
                                                        onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                                        name="secondNo"
                                                        value={plateNo.secondNo}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <input
                                                        className="border-0 text-center"
                                                        type="text"
                                                        placeholder="ص"
                                                        maxLength="1"
                                                        name="letter"
                                                        value={plateNo.letter}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <input
                                                        className="border-0 text-center"
                                                        type="text"
                                                        id="inputPelak"
                                                        placeholder="12"
                                                        onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                                        name="firstNo"
                                                        value={plateNo.firstNo}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto leftSide">
                                            <div className="flag">
                                                <img src={IranFlag} alt="iran's flag"/>
                                            </div>
                                            <div className="iranText text-center">
                                                <p>I.R.</p>
                                                <p>IRAN</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="input-group">*/}
                                    {/*    <input*/}
                                    {/*        type="text border-2 border-dark"*/}
                                    {/*        className="form-control"*/}
                                    {/*        placeholder="کد ملی"*/}
                                    {/*        aria-label="کد ملی"*/}
                                    {/*        style={{direction: 'ltr', height: '50px'}}*/}
                                    {/*        onChange={(e) => setNationalCode(e.target.value)}*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                    <hr/>
                                    <div className="d-grid gap-2 rounded-2 shadow mb-3 text-dark"
                                         style={{backgroundColor: 'var(--yellow-color)'}}>
                                        <input
                                            type="submit"
                                            className="btn"
                                            name="submit"
                                            value="جستجو"
                                            onClick={handleFormSubmit}
                                        />
                                    </div>
                                    <div className="d-grid gap-2">
                                        <input
                                            type="button"
                                            className="btn btn-dark shadow"
                                            name="button"
                                            value="اضافه کردن خودرو"
                                            onClick={goToAddCar}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                        {car &&
                            <div className="card mb-4">
                                <h5 className="card-header text-center bg-secondary text-white">اطلاعات خودرو</h5>
                                <div className="card-body">
                                    <table className="table table-bordered">
                                        <tbody>
                                        <tr>
                                            <td>
                                                مدل خودرو‌ :
                                            </td>
                                            <td>
                                                {car.model_name}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                رنگ :
                                            </td>
                                            <td>
                                                {car.color}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2">
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label" htmlFor="male">آقا</label>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="male"
                                                        value="male"
                                                        checked={car.car_owner.is_male}
                                                        disabled="disabled"
                                                    />
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label"
                                                           htmlFor="female">خانم</label>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="female"
                                                        value="female"
                                                        checked={!car.car_owner.is_male}
                                                        disabled="disabled"
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                نام مالک :
                                            </td>
                                            <td>
                                                {car.car_owner.name} {car.car_owner.lastname}
                                            </td>

                                        </tr>
                                        <tr>
                                            <td>
                                                موبایل‌ :
                                            </td>
                                            <td>اطلاعات خودرو

                                                {e2p(car.car_owner.mobile_number)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                تلفن ثابت :
                                            </td>
                                            <td>
                                                {e2p(car.car_owner.phone_number)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                نشانی‌ :
                                            </td>
                                            <td>
                                                {car.car_owner.address}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                توضیحات‌ :
                                            </td>
                                            <td>
                                                {car.car_owner.description}
                                            </td>
                                        </tr>
                                        <tr className="border-bottom-0">
                                            <td className="text-center border-0">
                                                <input type='button' className='custom-yellow-btn text-center'
                                                       onClick={() => handleShowHistory(car.id)} value='تاریخچه'/>
                                            </td>
                                            <td className="text-center border-0">
                                                <input type='button' className='custom-green-btn text-center'
                                                       style={{backgroundColor: 'var(--light-green-button-color)'}}
                                                       onClick={() => {
                                                           handleReception(car.id)
                                                       }} value='پذیرش'/>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    {showHistory &&
                                        <div>
                                            <div className="d-flex mt-2">
                                                <input type='button' className='btn btn-info'
                                                       onClick={handleHideHistory} value='بستن'/>
                                            </div>
                                            <div className="mt-2">
                                                <Report reportsData={history}/>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserPanel;
